var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C2A633;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,10.5h-2.3V15h3.6v1.9h-3.6v4.5h2.4c0.6,0,5,0.1,5-5.2S17.2,10.5,16.3,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0C7.1,0,0,7.1,0,16s7.1,16,16,16s16-7.1,16-16S24.8,0,16,0z M16.6,24.6h-5.8v-7.7h-2V15h2V7.3h5 c1.2,0,8.9-0.2,8.9,8.8C24.7,25.3,16.6,24.6,16.6,24.6L16.6,24.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.6e0b03b7e25e3417f5b243b90e5fa23c.svg";
export { ForwardRef as ReactComponent };